import { type DocumentType, graphql } from '@generated/gql';

export const AlertBannerInteractionFields = graphql(/** GraphQL */ `
  fragment AlertBannerInteractionFields on AlertBannerInteraction {
    id
    alertBanner {
      id
      name
      bannerType
      bannerCopy {
        ...OrganizationTranslatedString
      }
      configuration {
        displayOnWeb
        displayOnIOS
        displayOnAndroid
        makeDismissible
        enableAction
      }
      persistenceBehaviour
      actionButton {
        url
        label
      }
      createdAt
    }
  }
`);

export const FETCH_VISIBLE_ALERT_BANNERS = graphql(/** GraphQL */ `
  query alertBannerFetchVisibleAlertBanners(
    $input: FetchVisibleAlertBannersInput!
  ) {
    fetchVisibleAlertBanners(input: $input) {
      totalCount
      visibleAlertBanners {
        id
      }
    }
  }
`);

export const UPSERT_ALERT_BANNER_INTERACTIONS = graphql(/** GraphQL */ `
  mutation alertBannerUpsertAlertBannerInteractions(
    $input: UpsertAlertBannerInteractionsInput!
  ) {
    upsertAlertBannerInteractions(input: $input) {
      alertBannerInteractions {
        ...AlertBannerInteractionFields
      }
    }
  }
`);

export const TRANSITION_ALERT_BANNER_INTERACTION = graphql(/** GraphQL */ `
  mutation alertBannerTransitionAlertBannerInteraction(
    $input: TransitionAlertBannerInteractionInput!
  ) {
    transitionAlertBannerInteraction(input: $input) {
      alertBannerInteraction {
        id
      }
    }
  }
`);

export type AlertBannerInteractionItem = DocumentType<
  typeof AlertBannerInteractionFields
>;
